<mat-form-field
  class="galaxy-form-field galaxy-select-container mat-form-field-can-float {{
    isActive ? 'mat-form-field-should-float' : ''
  }}"
  [ngClass]="{
    'no-hint-message': !hint && (!formControl.invalid || formControl.pristine)
  }"
  appearance="outline"
>
  <mat-label *ngIf="!!label" [ngClass]="{ 'mat-form-field-empty': true, active: isActive }">
    {{ label | translate }}
  </mat-label>
  <input
    type="text"
    [placeholder]="placeholder"
    matInput
    [formControl]="formControl"
    [matAutocomplete]="auto"
    (blur)="handleOnBlur()"
    [class]="'galaxy-mat-select-panel is-dense'"
    (focus)="handleOnFocus()"
  />
  <mat-icon matSuffix [class]="isActive ? 'active' : ''">arrow_drop_down</mat-icon>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText" class="search-select-autocomplete">
    <ng-container *ngIf="filteredOptions$$ | async as filteredOptions">
      <mat-option
        *ngFor="let option of filteredOptions"
        [value]="option"
        (onSelectionChange)="handleOnSelectionChange($event)"
      >
        <span class="glxy-option-text label">
          {{ option.label | translate }}
        </span>
        <ng-container *ngIf="option | getOption as optionObj">
          <br />
          <span class="glxy-option-text description">
            {{ optionObj.description ?? '' | translate }}
          </span>
        </ng-container>
      </mat-option>
    </ng-container>
  </mat-autocomplete>
  <mat-hint class="galaxy-hint" *ngIf="hint">{{ hint | translate }}</mat-hint>

  <mat-error *ngIf="validatorError$ | async as validatorError">
    <ng-container *ngIf="validatorError !== ''">
      {{ validatorError | translate }}
    </ng-container>
  </mat-error>
</mat-form-field>
